class RoleGroupDto {
    Id: number;
    Name: string;
    UserRole: number;
    UserIds: number[];

    constructor(id: number, name: string, role: number, userIds: number[]) {
        this.Id = id;
        this.Name = name;
        this.UserRole = role;
        this.UserIds = userIds;
    }
}

export default RoleGroupDto;
